export const schemaNames = [
  "cosmos_auth_v1beta1_MsgUpdateParams",
  "cosmos_authz_v1beta1_MsgExec",
  "cosmos_authz_v1beta1_MsgGrant",
  "cosmos_authz_v1beta1_MsgRevoke",
  "cosmos_bank_v1beta1_MsgMultiSend",
  "cosmos_bank_v1beta1_MsgSend",
  "cosmos_bank_v1beta1_MsgSetSendEnabled",
  "cosmos_bank_v1beta1_MsgUpdateParams",
  "cosmos_base_abci_v1beta1_MsgData",
  "cosmos_base_abci_v1beta1_TxMsgData",
  "cosmos_base_reflection_v2alpha1_MsgDescriptor",
  "cosmos_circuit_v1_MsgAuthorizeCircuitBreaker",
  "cosmos_circuit_v1_MsgResetCircuitBreaker",
  "cosmos_circuit_v1_MsgTripCircuitBreaker",
  "cosmos_consensus_v1_MsgUpdateParams",
  "cosmos_crisis_v1beta1_MsgUpdateParams",
  "cosmos_crisis_v1beta1_MsgVerifyInvariant",
  "cosmos_distribution_v1beta1_MsgCommunityPoolSpend",
  "cosmos_distribution_v1beta1_MsgDepositValidatorRewardsPool",
  "cosmos_distribution_v1beta1_MsgFundCommunityPool",
  "cosmos_distribution_v1beta1_MsgSetWithdrawAddress",
  "cosmos_distribution_v1beta1_MsgUpdateParams",
  "cosmos_distribution_v1beta1_MsgWithdrawDelegatorReward",
  "cosmos_distribution_v1beta1_MsgWithdrawValidatorCommission",
  "cosmos_evidence_v1beta1_MsgSubmitEvidence",
  "cosmos_evm_vm_v1_MsgEthereumTx",
  "cosmos_evm_vm_v1_MsgUpdateParams",
  "cosmos_feegrant_v1beta1_AllowedMsgAllowance",
  "cosmos_feegrant_v1beta1_MsgGrantAllowance",
  "cosmos_feegrant_v1beta1_MsgPruneAllowances",
  "cosmos_feegrant_v1beta1_MsgRevokeAllowance",
  "cosmos_gov_v1_MsgCancelProposal",
  "cosmos_gov_v1_MsgDeposit",
  "cosmos_gov_v1_MsgExecLegacyContent",
  "cosmos_gov_v1_MsgSubmitProposal",
  "cosmos_gov_v1_MsgUpdateParams",
  "cosmos_gov_v1_MsgVote",
  "cosmos_gov_v1_MsgVoteWeighted",
  "cosmos_gov_v1beta1_MsgDeposit",
  "cosmos_gov_v1beta1_MsgSubmitProposal",
  "cosmos_gov_v1beta1_MsgVote",
  "cosmos_gov_v1beta1_MsgVoteWeighted",
  "cosmos_group_v1_MsgCreateGroup",
  "cosmos_group_v1_MsgCreateGroupPolicy",
  "cosmos_group_v1_MsgCreateGroupWithPolicy",
  "cosmos_group_v1_MsgExec",
  "cosmos_group_v1_MsgLeaveGroup",
  "cosmos_group_v1_MsgSubmitProposal",
  "cosmos_group_v1_MsgUpdateGroupAdmin",
  "cosmos_group_v1_MsgUpdateGroupMembers",
  "cosmos_group_v1_MsgUpdateGroupMetadata",
  "cosmos_group_v1_MsgUpdateGroupPolicyAdmin",
  "cosmos_group_v1_MsgUpdateGroupPolicyDecisionPolicy",
  "cosmos_group_v1_MsgUpdateGroupPolicyMetadata",
  "cosmos_group_v1_MsgVote",
  "cosmos_group_v1_MsgWithdrawProposal",
  "cosmos_mint_v1beta1_MsgUpdateParams",
  "cosmos_nft_v1beta1_MsgSend",
  "cosmos_slashing_v1beta1_MsgUnjail",
  "cosmos_slashing_v1beta1_MsgUpdateParams",
  "cosmos_staking_v1beta1_MsgBeginRedelegate",
  "cosmos_staking_v1beta1_MsgCancelUnbondingDelegation",
  "cosmos_staking_v1beta1_MsgCreateValidator",
  "cosmos_staking_v1beta1_MsgDelegate",
  "cosmos_staking_v1beta1_MsgEditValidator",
  "cosmos_staking_v1beta1_MsgUndelegate",
  "cosmos_staking_v1beta1_MsgUpdateParams",
  "cosmos_upgrade_v1beta1_MsgCancelUpgrade",
  "cosmos_upgrade_v1beta1_MsgSoftwareUpgrade",
  "cosmos_vesting_v1beta1_MsgCreatePeriodicVestingAccount",
  "cosmos_vesting_v1beta1_MsgCreatePermanentLockedAccount",
  "cosmos_vesting_v1beta1_MsgCreateVestingAccount",
  "cosmwasm_wasm_v1_MsgAddCodeUploadParamsAddresses",
  "cosmwasm_wasm_v1_MsgClearAdmin",
  "cosmwasm_wasm_v1_MsgExecuteContract",
  "cosmwasm_wasm_v1_MsgIBCCloseChannel",
  "cosmwasm_wasm_v1_MsgIBCSend",
  "cosmwasm_wasm_v1_MsgInstantiateContract",
  "cosmwasm_wasm_v1_MsgInstantiateContract2",
  "cosmwasm_wasm_v1_MsgMigrateContract",
  "cosmwasm_wasm_v1_MsgPinCodes",
  "cosmwasm_wasm_v1_MsgRemoveCodeUploadParamsAddresses",
  "cosmwasm_wasm_v1_MsgStoreAndInstantiateContract",
  "cosmwasm_wasm_v1_MsgStoreAndMigrateContract",
  "cosmwasm_wasm_v1_MsgStoreCode",
  "cosmwasm_wasm_v1_MsgSudoContract",
  "cosmwasm_wasm_v1_MsgUnpinCodes",
  "cosmwasm_wasm_v1_MsgUpdateAdmin",
  "cosmwasm_wasm_v1_MsgUpdateContractLabel",
  "cosmwasm_wasm_v1_MsgUpdateInstantiateConfig",
  "cosmwasm_wasm_v1_MsgUpdateParams",
  "elys_amm_MsgCreatePool",
  "elys_amm_MsgExitPool",
  "elys_amm_MsgFeedMultipleExternalLiquidity",
  "elys_amm_MsgJoinPool",
  "elys_amm_MsgSwapByDenom",
  "elys_amm_MsgSwapExactAmountIn",
  "elys_amm_MsgSwapExactAmountOut",
  "elys_amm_MsgUpdateParams",
  "elys_amm_MsgUpdatePoolParams",
  "elys_amm_MsgUpFrontSwapExactAmountIn",
  "elys_commitment_MsgCancelVest",
  "elys_commitment_MsgClaimAirdrop",
  "elys_commitment_MsgClaimKol",
  "elys_commitment_MsgClaimRewardProgram",
  "elys_commitment_MsgClaimVesting",
  "elys_commitment_MsgCommitClaimedRewards",
  "elys_commitment_MsgStake",
  "elys_commitment_MsgUncommitTokens",
  "elys_commitment_MsgUnstake",
  "elys_commitment_MsgUpdateAirdropParams",
  "elys_commitment_MsgUpdateEnableVestNow",
  "elys_commitment_MsgUpdateVestingInfo",
  "elys_commitment_MsgVest",
  "elys_commitment_MsgVestLiquid",
  "elys_commitment_MsgVestNow",
  "elys_estaking_MsgUpdateParams",
  "elys_estaking_MsgWithdrawAllRewards",
  "elys_estaking_MsgWithdrawElysStakingRewards",
  "elys_estaking_MsgWithdrawReward",
  "elys_leveragelp_MsgAddPool",
  "elys_leveragelp_MsgClaimRewards",
  "elys_leveragelp_MsgClose",
  "elys_leveragelp_MsgClosePositions",
  "elys_leveragelp_MsgDewhitelist",
  "elys_leveragelp_MsgOpen",
  "elys_leveragelp_MsgRemovePool",
  "elys_leveragelp_MsgUpdateEnabledPools",
  "elys_leveragelp_MsgUpdateParams",
  "elys_leveragelp_MsgUpdatePool",
  "elys_leveragelp_MsgUpdateStopLoss",
  "elys_leveragelp_MsgWhitelist",
  "elys_masterchef_MsgAddExternalIncentive",
  "elys_masterchef_MsgAddExternalRewardDenom",
  "elys_masterchef_MsgClaimRewards",
  "elys_masterchef_MsgTogglePoolEdenRewards",
  "elys_masterchef_MsgUpdateParams",
  "elys_masterchef_MsgUpdatePoolMultipliers",
  "elys_perpetual_MsgClose",
  "elys_perpetual_MsgClosePositions",
  "elys_perpetual_MsgDewhitelist",
  "elys_perpetual_MsgOpen",
  "elys_perpetual_MsgUpdateEnabledPools",
  "elys_perpetual_MsgUpdateMaxLeverageForPool",
  "elys_perpetual_MsgUpdateParams",
  "elys_perpetual_MsgUpdateStopLoss",
  "elys_perpetual_MsgUpdateTakeProfitPrice",
  "elys_perpetual_MsgWhitelist",
  "elys_stablestake_MsgAddPool",
  "elys_stablestake_MsgBond",
  "elys_stablestake_MsgUnbond",
  "elys_stablestake_MsgUpdateParams",
  "elys_stablestake_MsgUpdatePool",
  "elys_tradeshield_MsgCancelPerpetualOrder",
  "elys_tradeshield_MsgCancelPerpetualOrders",
  "elys_tradeshield_MsgCancelSpotOrder",
  "elys_tradeshield_MsgCancelSpotOrders",
  "elys_tradeshield_MsgCreatePerpetualCloseOrder",
  "elys_tradeshield_MsgCreatePerpetualOpenOrder",
  "elys_tradeshield_MsgCreateSpotOrder",
  "elys_tradeshield_MsgExecuteOrders",
  "elys_tradeshield_MsgUpdateParams",
  "elys_tradeshield_MsgUpdatePerpetualOrder",
  "elys_tradeshield_MsgUpdateSpotOrder",
  "ibc_applications_interchain_accounts_controller_v1_MsgRegisterInterchainAccount",
  "ibc_applications_interchain_accounts_controller_v1_MsgSendTx",
  "ibc_applications_interchain_accounts_controller_v1_MsgUpdateParams",
  "ibc_applications_interchain_accounts_host_v1_MsgModuleQuerySafe",
  "ibc_applications_interchain_accounts_host_v1_MsgUpdateParams",
  "ibc_applications_rate_limiting_v1_MsgAddRateLimit",
  "ibc_applications_rate_limiting_v1_MsgRemoveRateLimit",
  "ibc_applications_rate_limiting_v1_MsgResetRateLimit",
  "ibc_applications_rate_limiting_v1_MsgUpdateRateLimit",
  "ibc_applications_transfer_v1_MsgTransfer",
  "ibc_applications_transfer_v1_MsgUpdateParams",
  "ibc_core_channel_v1_MsgAcknowledgement",
  "ibc_core_channel_v1_MsgChannelCloseConfirm",
  "ibc_core_channel_v1_MsgChannelCloseInit",
  "ibc_core_channel_v1_MsgChannelOpenAck",
  "ibc_core_channel_v1_MsgChannelOpenConfirm",
  "ibc_core_channel_v1_MsgChannelOpenInit",
  "ibc_core_channel_v1_MsgChannelOpenTry",
  "ibc_core_channel_v1_MsgRecvPacket",
  "ibc_core_channel_v1_MsgTimeout",
  "ibc_core_channel_v1_MsgTimeoutOnClose",
  "ibc_core_channel_v2_MsgAcknowledgement",
  "ibc_core_channel_v2_MsgRecvPacket",
  "ibc_core_channel_v2_MsgSendPacket",
  "ibc_core_channel_v2_MsgTimeout",
  "ibc_core_client_v1_MsgCreateClient",
  "ibc_core_client_v1_MsgDeleteClientCreator",
  "ibc_core_client_v1_MsgIBCSoftwareUpgrade",
  "ibc_core_client_v1_MsgRecoverClient",
  "ibc_core_client_v1_MsgUpdateClient",
  "ibc_core_client_v1_MsgUpdateParams",
  "ibc_core_client_v1_MsgUpgradeClient",
  "ibc_core_client_v2_MsgRegisterCounterparty",
  "ibc_core_client_v2_MsgUpdateClientConfig",
  "ibc_core_connection_v1_MsgConnectionOpenAck",
  "ibc_core_connection_v1_MsgConnectionOpenConfirm",
  "ibc_core_connection_v1_MsgConnectionOpenInit",
  "ibc_core_connection_v1_MsgConnectionOpenTry",
  "ibc_core_connection_v1_MsgUpdateParams",
  "ibc_lightclients_wasm_v1_MsgMigrateContract",
  "ibc_lightclients_wasm_v1_MsgRemoveChecksum",
  "ibc_lightclients_wasm_v1_MsgStoreCode",
  "intento_alloc_v1_MsgFundFairburnPool",
  "intento_alloc_v1_MsgUpdateParams",
  "intento_claim_v1_MsgClaimClaimable",
  "intento_claim_v1_MsgUpdateParams",
  "intento_intent_v1_MsgCreateTrustlessAgent",
  "intento_intent_v1_MsgRegisterAccount",
  "intento_intent_v1_MsgRegisterAccountAndSubmitFlow",
  "intento_intent_v1_MsgSubmitFlow",
  "intento_intent_v1_MsgSubmitTx",
  "intento_intent_v1_MsgUpdateFlow",
  "intento_intent_v1_MsgUpdateParams",
  "intento_intent_v1_MsgUpdateTrustlessAgentFeeConfig",
  "intento_mint_v1_MsgUpdateParams",
  "osmosis_gamm_v1beta1_MsgExitPool",
  "osmosis_gamm_v1beta1_MsgExitSwapExternAmountOut",
  "osmosis_gamm_v1beta1_MsgExitSwapShareAmountIn",
  "osmosis_gamm_v1beta1_MsgJoinPool",
  "osmosis_gamm_v1beta1_MsgJoinSwapExternAmountIn",
  "osmosis_gamm_v1beta1_MsgJoinSwapShareAmountOut",
  "osmosis_gamm_v1beta1_MsgSwapExactAmountIn",
  "osmosis_gamm_v1beta1_MsgSwapExactAmountOut",
] as const;
export type SchemaNames = (typeof schemaNames)[number];
